import { render } from "./MarriageEditDialog.vue?vue&type=template&id=47a6f73e&scoped=true"
import script from "./MarriageEditDialog.vue?vue&type=script&lang=js"
export * from "./MarriageEditDialog.vue?vue&type=script&lang=js"

import "./MarriageEditDialog.vue?vue&type=style&index=0&id=47a6f73e&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a6f73e"]])

export default __exports__